import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Text, Box } from '@nerdwallet/currency';
import { NumStepper } from '@nerdwallet/react-stepper';

import { ENTITY_NAME, RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  formatMonths,
  inputOnChange,
} from '../../../../lib/utils';
import useAnalytics from '../../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

type onInputChange = OnChangeEvent | number;

const RentSecurityDepositInput: React.FC<RentVsBuyInput> = ({
  value,
  dispatch,
  label,
  tooltip,
  className,
}) => {
  const segmentAbstract = useAnalytics();

  const onInputChange = (e: onInputChange) => {
    // segment analytics
    debouncedTrackInputEvent(
      {
        field_type: 'increment-decrement-user_type_input',
        entityName: 'rent_security_deposit',
        field: 'Rent Security Deposit',
        field_value: e,
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      fieldName: 'rentSecurityDeposit',
      calculator: RENT_VS_BUY,
      inputType: 'number',
    });
  };

  return (
    <Box>
      <Text size="small">
        {label}
        <Tooltip
          placement="top"
          content={tooltip}
          analytics={{
            entityName: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            eventType: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            payload: {
              additional_attributes: {
                help_button_location: 'rentSecurityDeposit',
              },
            },
          }}
        />
      </Text>
      <Box className={className}>
        <NumStepper
          editable
          formatter={formatMonths}
          max={30}
          min={1}
          stepSize={1}
          value={value}
          onChange={onInputChange}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  value: state?.rentvsbuyCalculator?.inputs?.rentSecurityDeposit,
});

export default connect(mapStateToProps)(RentSecurityDepositInput);
